import { z } from 'zod';

/**
 * Canonical TraceEvent schema — shared between the browser trace recorder,
 * the mechanical story generator, and the data-contract extractor. Also the
 * parse boundary for trace payloads entering via req.body.
 */
export const TraceEventSchema = z.object({
  ts: z.number(),
  type: z.enum(['navigate', 'click', 'api', 'action', 'session-start']),
  detail: z.record(z.string(), z.unknown()),
});

export type TraceEvent = z.infer<typeof TraceEventSchema>;
